import * as React from 'react'

const ShelteredIcon = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
  >
    <path
      d="M1.59961 12.7031L12.2012 4.62305L17.2419 8.66309M22.2827 12.7031L17.2419 8.66309M17.2419 8.66309V4.62305"
      stroke="#4F5B94"
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <rect
      x="8.82812"
      y="14.5566"
      width="6.22656"
      height="6.22656"
      stroke="#4F5B94"
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
)

export default ShelteredIcon
